var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pl-1"},[(_vm.isAccomplished)?_c('font-awesome-icon',{staticClass:"text-success",attrs:{"icon":['far', 'check']}}):_vm._e(),_vm._v(" "),(_vm.isAccomplished == false)?_c('b-icon',{attrs:{"icon":"exclamation","variant":"danger","animation":"fade","scale":"2"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }